import { Highlightable } from '@angular/cdk/a11y';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  HostBinding,
  HostListener,
  Input,
  Output,
} from '@angular/core';

@Component({
  selector: 'portal-form-option',
  templateUrl: './option.component.html',
  styleUrls: ['./option.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OptionComponent<T> implements Highlightable {
  @HostBinding('class.mat-option') private readonly classMatOption = true;

  @HostBinding('class.mat-selected')
  protected isSelected = false;

  @HostBinding('class.mat-active')
  protected isActive = false;

  @Input()
  value: T | null = null;

  @Input()
  highlightSelected = true;

  @Input()
  @HostBinding('class.mat-option-disabled')
  @HostBinding('attr.aria-disabled')
  disabled = false;

  @Output()
  selected = new EventEmitter<OptionComponent<T>>();

  constructor(private cd: ChangeDetectorRef, private el: ElementRef<HTMLElement>) {}

  setActiveStyles(): void {
    this.isActive = true;
    this.cd.markForCheck();
  }

  setInactiveStyles(): void {
    this.isActive = false;
    this.cd.markForCheck();
  }

  scrollIntoView(options?: ScrollIntoViewOptions) {
    this.el.nativeElement.scrollIntoView(options);
  }

  highlightAsSelected() {
    if (!this.highlightSelected) return;
    this.isSelected = true;
    this.cd.markForCheck();
  }

  deselect() {
    this.isSelected = false;
    this.cd.markForCheck();
  }

  @HostListener('click')
  protected select() {
    if (!this.disabled) {
      this.highlightAsSelected();
      this.selected.emit(this);
    }
  }
}
